import React, { FC } from 'react'

import { CheckboxBasedFilter } from '@avantstay/backoffice-core'

import { getRiskVerificationStatusOption } from '@new/__global/constants/filter'

import { FiltersSharedProps } from './Filters.types'

interface BookingsRiskVerificationStatusProps extends FiltersSharedProps {
  title: string
  statusList: string[]
  initialValue?: string[]
  onChange: (value?: string[]) => void
  isLoadingOptions?: boolean
  shouldUpdateOnInitialValueChange?: boolean
}

export const BookingsRiskVerificationStatusFilter: FC<BookingsRiskVerificationStatusProps> = ({
  statusList,
  ...props
}) => {
  const options = statusList.map(item => getRiskVerificationStatusOption(item)) || []

  return <CheckboxBasedFilter options={options} {...props} />
}
